module.exports = __webpack_public_path__ + "img/advantage2_1@2x.c7d1a00b.png";